import React from 'react';
import { FiFileText, FiEdit2, FiCalendar, FiUser, FiClipboard, FiAlertCircle } from 'react-icons/fi';

const STAGE_CONFIG = {
  intake: { label: 'Intake', color: '#435654' },
  proofs: { label: 'Proofs', color: '#304849' },
  selection: { label: 'Selection', color: '#3e5c58' },
  retouch: { label: 'Retouch', color: '#3e5c58' },
  delivery: { label: 'Delivery', color: '#10b981' },
  complete: { label: 'Complete', color: '#059669' }
};

function formatDate(value) {
  if (!value) return ', ';
  return new Date(value).toLocaleDateString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric'
  });
}

function getDaysUntilDue(dueDate) {
  if (!dueDate) return null;
  const due = new Date(dueDate);
  const now = new Date();
  return Math.ceil((due - now) / (1000 * 60 * 60 * 24));
}

export default function DetailsCard({ job, documents, notes, onEditClick }) {
  const stage = STAGE_CONFIG[job.stage] || STAGE_CONFIG.intake;
  const daysUntil = getDaysUntilDue(job.due_date);

  return (
    <div className="ws-card">
      <div className="ws-card-header">
        <h4><FiFileText size={15} /> Details</h4>
        <button className="ws-card-action" onClick={onEditClick}>
          <FiEdit2 size={13} /> Edit
        </button>
      </div>

      <div className="ws-card-body">
        <div className="details-grid">
          <div className="detail-row">
            <span className="detail-label">Stage</span>
            <span className="stage-pill" style={{ '--stage-color': stage.color }}>
              {stage.label}
            </span>
          </div>

          <div className="detail-row">
            <span className="detail-label"><FiUser size={12} /> Client</span>
            <span className="detail-value">{job.customer?.name || job.customer_name || ', '}</span>
          </div>

          {job.due_date && (
            <div className="detail-row">
              <span className="detail-label"><FiCalendar size={12} /> Due</span>
              <span className={`detail-value ${daysUntil !== null && daysUntil < 0 ? 'overdue' : daysUntil !== null && daysUntil <= 7 ? 'due-soon' : ''}`}>
                {formatDate(job.due_date)}
                {daysUntil !== null && daysUntil < 0 && (
                  <FiAlertCircle size={12} className="overdue-icon" />
                )}
              </span>
            </div>
          )}

          {documents && documents.length > 0 && (
            <div className="detail-row">
              <span className="detail-label"><FiClipboard size={12} /> Docs</span>
              <span className="detail-value">{documents.length}</span>
            </div>
          )}

          {notes && notes.length > 0 && (
            <div className="detail-row">
              <span className="detail-label"><FiClipboard size={12} /> Notes</span>
              <span className="detail-value">{notes.length}</span>
            </div>
          )}
        </div>

        {job.description && (
          <p className="description-snippet">
            {job.description.length > 120 ? job.description.slice(0, 120) + '...' : job.description}
          </p>
        )}
      </div>
    </div>
  );
}
